<template>
  <div class="login">
    <div class="login-inner">
      <form
        class="login-form"
        method="POST"
        @submit.prevent="login"
        autocomplete="off"
      >
        <img
          src="@/assets/ceara-login.png"
          alt="Ceara"
        >
        <h2 class="login-form-title">
          ACCESO EXTRANET
        </h2>
        <label
          for="email"
          class="login-form-control"
        >
          <input
            type="text"
            id="email"
            name="email"
            class="login-form-input"
            v-model="email"
          >
        </label>
        <label
          for="password"
          class="login-form-control"
        >
          <input
            type="password"
            id="password"
            name="password"
            class="login-form-input"
            v-model="password"
          >
        </label>
        <div class="py-3">
          <button class="btn btn-orange btn-sm">
            INGRESAR
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: ''
    }
  },

  methods: {
    login () {
      this.$store.dispatch('user/LOGIN', this.$data).then(() => {
        this.$router.push(this.$route.params.fullPath || '/')
      })
    }
  }
}
</script>
